import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Penguin species",
  "description": "",
  "published": "2007-06-10T00:00:00.000Z",
  "redirect_from": ["/blog/penguin-species/swizec/194"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A lot of things to say have been piling up lately and not much to say them, but let's try and remedy that by commencing with the saying of the oldest in a chronological order and then try saying the others as soon as technically possible.`}</p>
    <p>{`On Wednesday I borked my computer into a irredeemable mess of turd. The more I tried fixing it the less stuff was working. It is out of these fatal conditions that my decision arose. I would change the flavour of penguins that run the intricate little gearsin my difference machine. And thus I downloaded Kubuntu.`}</p>
    <p>{`Right away I noticed that a basically working installation of Kubuntu only took me about an hour as opposed to two or so days with Gentoo. The next thing I noticed was how quickly the very same installation rose and grew to something more my taste with packages downloading quickly and all that. Lovely.`}</p>
    <p>{`Setting up my ATI X1600 for a dual screen setup as I had before didn't take as long as it did the last time, only about two hours of tinkering ... possibly because I had saved the configuration files, yes quite possibly, but they didn't work right away, still. The next thing to do was configuring my sound to work a little bit better and here's where the only very major drawback of linux rears its ugly head. There is no simple way of configuring your sound for 5.1 and proper dmixing. Right now I can only have either dmixing or 5.1, oh well, we'll get her configured.`}</p>
    <p>{`The qualm I do have with kubuntu is that for some suspiciously odd reason the Opera browser cannot be installed in a simple manner and some other important things aren't in repositories. Also why in the world don't mp3s and other multimedia work right out of the box. This is supposed to be a newbie distro right? Why then so many intricate steps to get the most basic thing of a desktop computer working? Why!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      